/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: none;
  position: fixed;
  inset: 0;
  width: fit-content;
  height: fit-content;
}

:host([open]) {
  display: block;
}

.qds-dialog {
  background-color: var(--qds-theme-popup-background);
  border-radius: var(--qds-popup-border-radius);
  border: var(--qds-popup-border-width) solid var(--qds-theme-popup-border);
  box-shadow: var(--qds-theme-popup-elevation);
  height: inherit;
  padding: 0;
  width: inherit;

  &::backdrop {
    background: initial;
  }

  &[open] ~ .qds-backdrop {
    backdrop-filter: blur(var(--qds-theme-popup-overlay-blur));
    background-color: var(--qds-theme-popup-overlay-background);
    inset: 0;
    opacity: var(--qds-theme-popup-overlay-opacity);
    position: fixed;
  }
}

.qds-title,
.qds-content,
.qds-footer {
  padding: var(--qds-popup-padding) var(--qds-popup-padding)
    var(--qds-popup-section-padding);
}

.qds-content {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: var(--qds-popup-gap-children-related);
  padding: var(--qds-popup-padding);
  height: calc(100% - 2 * var(--qds-popup-padding));
}

::slotted(blockquote),
::slotted(button),
::slotted(dd),
::slotted(dl),
::slotted(fieldset),
::slotted(figure),
::slotted(h1),
::slotted(h2),
::slotted(h3),
::slotted(h4),
::slotted(h5),
::slotted(h6),
::slotted(hr),
::slotted(input),
::slotted(menu),
::slotted(ol),
::slotted(p),
::slotted(pre),
::slotted(select),
::slotted(textarea),
::slotted(ul) {
  margin: 0;
}
